import React from 'react';
import { ProjectileState } from '@tankworld/shared';

interface ProjectilesRendererProps {
  projectiles: ProjectileState[];
}

export const ProjectilesRenderer: React.FC<ProjectilesRendererProps> = ({ projectiles }) => {
  return (
    <group>
      {projectiles.map((proj) => (
        <group key={proj.id} position={[proj.position.x, proj.position.y, proj.position.z]}>
          {/* Glowing tracer shell core */}
          <mesh>
            <sphereGeometry args={[0.3, 8, 8]} />
            <meshBasicMaterial color="#ffaa22" />
          </mesh>
          {/* Subtle light around projectile */}
          <pointLight color="#ff8800" intensity={2} distance={8} />
        </group>
      ))}
    </group>
  );
};
